import * as Moment from "moment";
import { Department } from "../department";
import { User } from "../user";

/**
 * 診療科コード・職員コードは期限が切れた情報が入っている可能性あるため、
 * ダイアログから選択したタイミングで使ってよい情報かどうかを検証したほうがよさそう
 */
export class HospitalizationHistoryInformation {
  constructor(public admissionDateText: string, public dischageDateText: string, public department: Department, public doctors: User[]) {
  }

  get admissionDate(): Date {
    if (!this.admissionDateText) { return null; }
    return Moment(this.admissionDateText, "YYYYMMDD").toDate();
  }

  get dischargeDate(): Date {
    if (!this.dischageDateText) { return null; }
    return Moment(this.dischageDateText, "YYYYMMDD").toDate();
  }

  clone(): HospitalizationHistoryInformation {
    return new HospitalizationHistoryInformation(
      this.admissionDateText,
      this.dischageDateText,
      this.department ? this.department.clone() : this.department,
      this.doctors);
  }
}
